<app-upsell-card
  htmlTitle="<strong>Get the Full Picture:</strong> Comprehensive Health Panel"
  question="We strongly recommend including a comprehensive health panel with your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Many men don’t realize that hidden health factors—like cholesterol, thyroid imbalance, inflammation, or nutrient
    deficiencies—can quietly interfere with energy, circulation, and sexual performance.
  </p>
  <p class="mb-4">
    A <strong>Comprehensive Health Panel</strong> helps uncover these issues so treatment can be better targeted and
    more effective.
  </p>
  <p class="mb-4">
    This panel evaluates key markers including
    <strong
      >blood health, organ function, cholesterol, thyroid function, iron levels, hydration, and inflammation</strong
    >—giving clinicians a clear view of what may be impacting your results.
  </p>
</app-upsell-card>
